import React from "react";
import Page from "./page";

/**
 * Technician Calendar entry component used by routing.
 * Delegates to the full scheduler implementation in `page.tsx`.
 */
const TechnicianCalendar: React.FC = () => {
  return <Page />;
};

export default TechnicianCalendar;

